import React from 'react';
import { observer } from 'mobx-react';
import EditGroupComponent from './Edit-group.component';
import useEditGroup from './useEditGroup';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, store, lang, handlers } = useEditGroup(onClose);

    return (
        <>
            <EditGroupComponent
                lang={lang.lang}
                loading={store.changeGroupDescriptionLoading || store.loading}
                groupName={state.groupName}
                groupNameError={state.groupNameError}
                serverError={store.serverError}
                onGroupNameChange={handlers.handleGroupNameChange}
                onSaveClick={handlers.handleSaveClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const EditGroupContainer = observer(Container);

export default EditGroupContainer;
